module.exports = __webpack_public_path__ + "img/cloud-download-alt.6085e300.svg";